import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import user from './user'
import person from './person'
import currentuser from './currentuser'
import company from './company'
import application from './application'
import criterias from './criterias'
import order from './order'
import basic from './basic'

import i18n from '@/locale'
Vue.use(Vuex)
Vue.use(i18n)

const store = new Vuex.Store({
  modules: {
    app,
    currentuser,
    user,
    person,
    company,
    application,
    criterias,
    order,
    basic
  },

  actions: {
    async init({dispatch}) {
      console.log('Store - init')
      await Promise.all([
        //- Things to do on app start (After API is up)
        dispatch('app/setApiVersion'),
        dispatch('currentuser/loadCurrentUser'),
        dispatch('loadCurrentLocale'),
      ])
        .then(res => {
          dispatch('onWasInitialized')
        })
        .catch(error => {
          console.log('Error in init: ', error)
        })
    },

    onWasLoggedOut({dispatch}) {
      console.log('Store - onWasLoggedOut')

      //- Clear localstore
      localStorage.removeItem('user')

      //- User Was logged out
      return Promise.all([dispatch('currentuser/setCurrentUser', null)])
    },

    onWasInitialized({dispatch}) {
      console.log('Store - onWasInitialized')

      //- Set init flag
      return dispatch('app/setInitialized', true)
    },

    loadCurrentLocale({dispatch}) {
      console.log('loadCurrentLocale')
      // Grab user data from local storage (only swedish for now)
      // localStorage.getItem('locale')
      const locale = 'sv'
      i18n.locale = locale 
      // Set locale or default
      return dispatch('app/setLocale', locale)
    }
  }
})

export default store
